<template>
  <div>
    <SysDialogFullScreen v-model="COMPUTED_DIALOG">
      <template #titulo>
        <v-btn icon class="ml-n2 mr-5" dark @click="COMPUTED_DIALOG = false">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        {{ COMPUTED_TITULO_DIALOG }}

        <v-divider inset vertical dark class="mx-2" />

        <span
          class="font-14 text-truncate"
          v-html="`${COMPUTED_TITULO_NOME_EVENTO} ${COMPUTED_TITULO_PERIODO_EVENTO}`"
        />

        <v-spacer />

        <v-badge
          bordered
          color="white"
          overlap
          class="mr-2"
        >
          <template v-slot:badge>
            <span style="color: #000000">{{ GET_ITENS_EVENTO.length }}</span>
          </template>

          <v-btn
            small
            color="primary"
            :disabled="GET_ITENS_EVENTO.length === 0"
            @click="abrirDialogListaEvento()"
            class="ma-0"
          >
            Lista de Evento
          </v-btn>
        </v-badge>

        <ListaEvento />
      </template>

      <div style="height: calc(100vh - 65px)">
        <div style="height: calc(100vh * 0.05)">
          <v-row class="ma-0">
            <v-col cols="auto" align-self="start">
              <Ano />
            </v-col>

            <v-col cols="auto" align-self="start">
              <Periodo />
            </v-col>

            <v-col cols="auto" align-self="start">
              <SystockFiltros
                v-model="COMPUTED_SYSTOCK_FILTROS"
                @aplicar-filtros="aplicarSystockFiltros()"
                class="mt-1"
              >
                <template #filtros-adicionais>
                  <v-col>
                    <SysStatusProduto v-model="COMPUTED_SYSTOCK_FILTROS.status_produto" />
                  </v-col>

                  <v-col>
                    <SysHistograma v-model="COMPUTED_SYSTOCK_FILTROS.histograma" />
                  </v-col>

                  <v-col class="mb-0">
                    <v-switch
                      v-model="COMPUTED_ITENS_NAO_VENDIDO"
                      inset
                      label="Exibir itens não vendido"
                    />
                  </v-col>
                </template>
              </SystockFiltros>
            </v-col>

            <v-col cols="auto" align-self="start">
              <v-switch
                v-model="COMPUTED_QTDE_FAT"
                hide-details
                inset
                style="margin-top: 7px !important;"
                @change="aplicarSystockFiltros()"
              >
                <template #label>
                  Qtde
                  <v-icon class="mx-2">mdi-arrow-left-right</v-icon>
                  Fat
                </template>
              </v-switch>
            </v-col>
          </v-row>
        </div>

        <div style="height: calc(100vh * 0.4) !important;">
          <Grafico />
        </div>

        <div style="height: calc(100vh * 0.46) !important;">
          <Tabela />
        </div>
      </div>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
import Grafico from './Grafico/Index.vue';
import Tabela from './Tabela/Index.vue';
import ListaEvento from '../ListaEvento/Index.vue';
import Ano from '../Filtros/Ano.vue';
import Periodo from '../Filtros/Periodo.vue';
import SystockFiltros from '../Filtros/SystockFiltros.vue';
import moment from 'moment';
import SysStatusProduto from '@/components/utils/crud/SysStatusProduto.vue';
import SysHistograma from '../Filtros/SysHistograma.vue';

export default {
  components: {
    SysDialogFullScreen,
    Grafico,
    Tabela,
    ListaEvento,
    Ano,
    Periodo,
    SystockFiltros,
    SysStatusProduto,
    SysHistograma
  },
  computed: {
    ...mapGetters({
      GET_DIALOG_GRAFICO_TABELA: 'EventoSazonalFinal/GET_DIALOG_GRAFICO_TABELA',
      GET_ITENS_EVENTO: 'EventoSazonalFinal/GET_ITENS_EVENTO',
      GET_FILTROS_GRAFICO_TABELA: 'EventoSazonalFinal/GET_FILTROS_GRAFICO_TABELA',
      GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
    }),
    COMPUTED_DIALOG: {
      get() { return this.GET_DIALOG_GRAFICO_TABELA },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setDialogGraficoTabela', value) }
    },
    COMPUTED_SYSTOCK_FILTROS: {
      get() { return this.GET_FILTROS_GRAFICO_TABELA.systock_filtros },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setFiltrosGraficoTabela', { systock_filtros: value }); },
    },
    COMPUTED_STATUS_PRODUTO: {
      get() { return this.GET_FILTROS_GRAFICO_TABELA.systock_filtros.status_produto },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setFiltrosGraficoTabela', { systock_filtros: value }); },
    },
    COMPUTED_ITENS_NAO_VENDIDO: {
      get() { return this.GET_FILTROS_GRAFICO_TABELA.itens_nao_vendido },
      set(valor) { this.$store.dispatch('EventoSazonalFinal/setFiltrosGraficoTabela', { itens_nao_vendido: valor }); }
    },
    COMPUTED_QTDE_FAT: {
      get() { return this.GET_FILTROS_GRAFICO_TABELA.qtde_faturamento },
      set(valor) {  this.$store.dispatch('EventoSazonalFinal/setFiltrosGraficoTabela', { qtde_faturamento: valor }); }
    },
    COMPUTED_TITULO_DIALOG() {
      return `Seleção dos produtos`;
    },
    COMPUTED_TITULO_NOME_EVENTO() {
      const { nome_evento } = this.GET_FORM_NOVO_EVENTO;
      return `Evento <span class="font-weight-bold">${nome_evento}</span>`;
    },
    COMPUTED_TITULO_PERIODO_EVENTO() {
      const { data_inicial, data_final } = this.GET_FORM_NOVO_EVENTO;

      const data_inicial_formatada = moment(data_inicial).format('DD/MM/YYYY');
      const data_final_formatada = moment(data_final).format('DD/MM/YYYY');

      return `de ${data_inicial_formatada} até ${data_final_formatada}`;
    }
  },
  methods: {
    abrirDialogListaEvento() {
      this.$store.dispatch('EventoSazonalFinal/setDialogListaEvento', true);
    },
    aplicarSystockFiltros() {
      this.$store.dispatch('EventoSazonalFinal/buscarDadosGrafico');
      this.$store.dispatch('EventoSazonalFinal/buscarDadosTabela');
    },
  }
}
</script>
